import React from 'react';
import { colors, borderRadius, shadows, transitions } from '../../styles/theme';

/**
 * Card Component - Reusable card container
 * @param {Object} props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.variant - 'default' | 'outlined' | 'elevated'
 * @param {string} props.padding - 'sm' | 'md' | 'lg'
 * @param {Function} props.onClick - Click handler
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 */
function Card({
  children,
  variant = 'default',
  padding = 'md',
  onClick,
  className = '',
  style = {},
}) {
  const paddingMap = {
    sm: '12px',
    md: '16px',
    lg: '24px',
  };

  const variantStyles = {
    default: {
      backgroundColor: colors.surface,
      border: `1px solid ${colors.border}`,
      boxShadow: shadows.sm,
    },
    outlined: {
      backgroundColor: colors.surface,
      border: `1px solid ${colors.border}`,
      boxShadow: 'none',
    },
    elevated: {
      backgroundColor: colors.surface,
      border: 'none',
      boxShadow: shadows.md,
    },
  };

  const baseStyles = {
    borderRadius: borderRadius.lg,
    padding: paddingMap[padding],
    transition: `box-shadow ${transitions.normal}, transform ${transitions.normal}`,
    cursor: onClick ? 'pointer' : 'default',
    ...variantStyles[variant],
    ...style,
  };

  const handleMouseEnter = (e) => {
    if (onClick) {
      e.currentTarget.style.boxShadow = shadows.lg;
      e.currentTarget.style.transform = 'translateY(-2px)';
    }
  };

  const handleMouseLeave = (e) => {
    if (onClick) {
      e.currentTarget.style.boxShadow = variantStyles[variant].boxShadow;
      e.currentTarget.style.transform = 'translateY(0)';
    }
  };

  return (
    <div
      className={`card ${className}`}
      style={baseStyles}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
}

export default Card;
